import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { NetworkStatus } from '@cbridge-utils/network';
import { clientLpListSelector } from '@cbridge-packages/lp-client';
import { compareStrings } from '@cbridge-utils/object';
import { lpAsNavigationItem } from './_helpers/lpAsNavigationItem';

export const lpSubNavigationPropsSelector = createCachedSelector(
  [
    path(clientLpListSelector).list(),
    path(clientLpListSelector).networkStatus(),
  ],
  (lpList, networkStatus) => {
    return {
      items: [...(lpList ?? [])]
        .sort((a, b) => compareStrings(a.name, b.name))
        .map(lpAsNavigationItem),
      isLoading: networkStatus !== NetworkStatus.Done && networkStatus !== NetworkStatus.Failed,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
